import React, { Component } from "react";
import Api from "../services/ServiceApi";
// import { Spin } from "antd";
import Cookies from "js-cookie";
import ChangePath from "../services/ServiceApi";
// import { PrinterFilled } from "@ant-design/icons";
import moment from "moment";
import { Avatar } from "antd";

let dataIsNotNull = false;
function setCookies(job_id, job_progress_id, job_type_id, maType) {
  Cookies.set("maType", maType);
  Cookies.set("job_id", job_id);
  Cookies.set("job_progress_id", job_progress_id);
  Cookies.set("job_type_id", job_type_id);
  setTimeout(function () {
    window.location.assign("/MaxiOperation/full_detail_job");
  }, 100);
}

class Noti extends Component {
  intervalID = 0;
  constructor(props) {
    super(props);
    this.state = {
      noti: [],
    };
  }
  getNotiDataFunction() {
    if (Cookies.get("project_id")) {
      Api.get(
        `notification/gethistory?userId=${Cookies.get(
          "userId"
        )}&companyId=${Cookies.get("companyid")}&operatorId=${Cookies.get(
          "operator_id"
        )}&projectId=${Cookies.get("project_id")}`
      ).then((res) => {
        let notiDataList = [];
        (res.data.data === null ? [] : res.data.data).forEach((i) => {
          const item = {
            ...i,
          };
          notiDataList.push(item);
          dataIsNotNull = true;
        });
        this.setState({ noti: [...notiDataList] });
      });
    }

    // console.log("data is returned");
  }
  componentDidMount() {
    this.getNotiDataFunction();
  }

  componentDidUpdate() {
    const time = process.env.REACT_APP_DELAY_REQUEST_API_MINUTE * 1000 * 5;
    if (this.intervalID !== 0) {
      clearInterval(this.intervalID);
    }
    this.intervalID = setInterval(() => {
      this.getNotiDataFunction();
    }, time);
    // console.log('component is updated', this.intervalID)
  }

  componentWillUnmount() {
    // console.log('component is unmount', this.intervalID)
    clearInterval(this.intervalID);
  }

  handleClick = async (item) => {
    // console.log(item);

    const getalljob = await Api.post("oper_get_query_group_list", {
      company_id: "1",
      operator_id: "0",
      project_id: "0",
      query_id: "1",
      query_module: "oper",
      param_text:
        "@company_id:$" +
        Cookies.get("companyid") +
        "##@operator_id:$" +
        Cookies.get("operator_id") +
        "##@project_id:$" +
        Cookies.get("project_id"),
      where_cond: "",
    });

    const result = getalljob.data.data.result_ma_job_list.filter(
      (word) => word.job_id === item.jobId
    );
    if (result.length > 0) {
      setCookies(
        result[0].job_id,
        result[0].job_progress_id,
        result[0].job_type_id,
        result[0].ma_type
      );
    }

    // Api.post("getuserpermission", {
    //   "company_id": Cookies.get("companyid"),
    //   "operator_id": Cookies.get("operator_id"),
    //   "project_id": Cookies.get("project_id")
    // })
    //   .then((res) => {
    //     const result = res.data.data.table.filter(data => parseInt(data.external_wf_id) === parseInt(Cookies.get("userId")));
    //     if (result.length === 1 ) {
    //       localStorage.setItem('permission',result[0]["status_permission"] === 0 ? 0 :  1);
    //       setTimeout(
    //         function () {
    //           //console.log('setTimeout',item.link);
    //           if(Cookies.get("operator_id") === "3"){
    //             Cookies.set("bus_booking_id", item.jobId);
    //             window.location.assign(result[0]["status_permission"] === 0 ? "/MaxiOperation/job_detail_view_only" : "/MaxiOperation/job_detail");
    //           }
    //           else{
    //             window.location.assign(item.link);
    //           }

    //         }.bind(this),
    //         1000
    //       );
    //       setCookies(
    //         item.jobId,
    //         item.job_progress_id,
    //         item.job_type_id,
    //         item.ma_type
    //       )
    //     }
    //     else {
    //       localStorage.setItem('permission', 0);
    //       setTimeout(
    //         function () {
    //           //console.log('setTimeout',item.link);
    //           if(Cookies.get("operator_id") === "3"){
    //             Cookies.set("bus_booking_id", item.jobId);
    //             window.location.assign("/MaxiOperation/job_detail_view_only");
    //           }
    //           else{
    //             window.location.assign(item.link);
    //           }

    //         }.bind(this),
    //         1000
    //       );
    //     }

    //   })
    //   .catch((e) => {
    //     localStorage.setItem('permission', 0);
    //   });
  };

  render() {
    const { noti } = this.state;
    return dataIsNotNull ? (
      <div className="wrapper-noti position-fixed">
        <div className="ant-collapse-item ant-collapse-item-active mt-1">
          <div>
            <span
              className="c-blue text-uppercase  ml-1 mb-3"
              style={{ fontSize: "18px" }}
            >
              <img
                src={ChangePath.absoluteUrl("/icon/notifications.svg")}
                width="30"
                alt=""
              />
              <a
                // onClick={() => setCookies(item.job_id, item.job_progress_id)}
                href={Api.absoluteUrl("/notifications")}
                className="c-blue text-underline"
              >
                <b className="ml-1">NOTIFICATIONS</b>
              </a>
            </span>
          </div>
          <ul>
            {noti.map((item, index) => (
              <li
                style={{
                  height: "auto",
                  borderBottom: "1px solid #e8ecef",
                  margin: "0 8px",
                  padding: "14px 12px",
                  backgroundColor: !item.isRead ? "#e7f3ff" : "#fff",
                }}
                className="d-flex justify-content-between"
                key={index}
                onClick={() => this.handleClick(item)}
              >
                <div
                  className="row"
                  style={{ alignItems: "center", width: "100%" }}
                >
                  <div className="ml-2">
                    <Avatar
                      style={{
                        backgroundColor: "#fde3cf",
                        verticalAlign: "middle",
                        color: "#f56a00",
                      }}
                      size="large"
                      gap="#fde3cf"
                    >
                      {item.sendFromEmpName?.charAt(0).toUpperCase()}
                    </Avatar>
                  </div>
                  <div className="col" style={{ paddingLeft: 15 }}>
                    <div className="row">
                      <div className="col-8" style={{ padding: 3 }}>
                        <h5 className="font-thai-b fs-18 m-0">{item.title}</h5>
                      </div>
                      <div
                        className="col-4"
                        style={{ padding: 3, textAlign: "end" }}
                      >
                        <span
                          className="font-thai-r fs-18"
                          style={{ color: "rgba(0,0,0,.5)" }}
                        >
                          {moment(item.createDate).format("HH:mm | DD MMM YY")}
                        </span>
                      </div>
                    </div>

                    <p className="font-thai-r fs-18" style={{ margin: 0 }}>
                      {item.message}
                    </p>
                    <p className="font-thai-r fs-18" style={{ margin: 0 }}>
                      {`Job No : ${item.jobNo}`}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    ) : (
      <div className="wrapper-noti position-fixed">
        <div className="ant-collapse-item ant-collapse-item-active mt-1">
          <span
            className="c-blue text-uppercase  ml-1 mb-3"
            style={{ fontSize: "18px" }}
          >
            <img
              src={ChangePath.absoluteUrl("/icon/notifications.svg")}
              width="30"
              alt=""
            />
            <a
              // onClick={() => setCookies(item.job_id, item.job_progress_id)}
              href={Api.absoluteUrl("/notifications")}
              className="c-blue text-underline"
            >
              <b className="ml-1">NOTIFICATIONS</b>
            </a>
          </span>
        </div>
        <div style={{ textAlign: "center" }}>
          <span style={{ color: "red" }}>"ไม่มีการแจ้งเตือน"</span>
        </div>
      </div>
    );
  }
}
export default Noti;
